import '../../css/homepage.css';
import { render } from '../main';
import { store } from '../state';
import { LEGAL } from '../legal';

const logoUrl = new URL('../../images/logo/logo-white-256w.png', import.meta.url).href;
const logoTextUrl = new URL('../../images/logo-22questions/22questions-nobg-300w.png', import.meta.url).href;

export function renderTerms(): void {
  const app = document.getElementById('app')!;
  app.className = 'hp-page';
  document.documentElement.classList.add('hp-active');
  document.body.classList.add('hp-active');

  const isLoggedIn = !!store.getState().accessToken;

  render(`
    <!-- Navigation -->
    <nav class="hp-nav">
      <a href="#/welcome" class="hp-nav-logo">
        <img src="${logoTextUrl}" alt="22 Questions" class="hp-nav-logo-img">
      </a>
      <div class="hp-nav-inner">
        ${isLoggedIn
          ? '<a href="#/about-me" class="btn btn-primary btn-sm">My Account</a>'
          : '<a href="#/login" class="btn btn-primary btn-sm">Sign In</a>'
        }
      </div>
    </nav>

    <!-- Scrollable Content -->
    <div class="hp-content">
      <section class="hp-section">
        <div class="hp-section-inner">
          <div class="hp-section-card legal-card">
            ${LEGAL.termsOfService}
          </div>
        </div>
      </section>

      <!-- Footer -->
      <footer class="hp-footer">
        <div class="hp-footer-inner">
          <div class="hp-footer-logo">
            <img src="${logoUrl}" alt="22 Questions">
            <img src="${logoTextUrl}" alt="22 Questions" class="hp-footer-logo-img">
          </div>
          <p class="hp-footer-text">
            Independent. No Match Group. No Bumble Inc. No venture mandate to extract users.
          </p>
          <div class="hp-footer-legal">
            <a href="#/privacy">Privacy Policy</a>
            <span class="hp-footer-divider">|</span>
            <a href="#/terms">Terms of Service</a>
            <span class="hp-footer-divider">|</span>
            <a href="#/contact">Contact</a>
          </div>
        </div>
      </footer>
    </div><!-- /.hp-content -->
  `, false);
}
